import {
  Grid,
  GridItem,
  RadioCard,
  RadioGroupField,
  Text,
} from "@certn/cascadia-react";
import { slugify } from "@certn/utils";
import { Field } from "formik";
import { t } from "i18next";

import { useDeleteReasons } from "../../../hooks/api/useDeleteReasons";

export function DeleteAccountReasons() {
  const { deleteReasons } = useDeleteReasons();

  return (
    <Grid form>
      <GridItem>
        <Text style="global/heading-medium">
          {t("Tell us why you’re leaving")}
        </Text>
      </GridItem>
      <GridItem>
        <Field
          name="reason"
          as={RadioGroupField}
          aria-label={t("Tell us why you’re leaving")}
          isRequired
          testID="delete-account-modal-radio-group"
        >
          {deleteReasons?.map((reason) => (
            <RadioCard
              key={reason.reason}
              description={
                <div dangerouslySetInnerHTML={{ __html: reason.more_info }} />
              }
              name={reason.reason}
              value={reason.reason}
              testID={`delete-your-account-${slugify(
                reason.reason
              )}-radio-button`}
            >
              {reason.description}
            </RadioCard>
          ))}
        </Field>
      </GridItem>
    </Grid>
  );
}
